// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackOutlinedSvg from "@ant-design/icons-svg/es/asn/SlackOutlined";
import AntdIcon from '../components/AntdIcon';

var SlackOutlined = function SlackOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackOutlinedSvg
  }));
};

SlackOutlined.displayName = 'SlackOutlined';
export default React.forwardRef(SlackOutlined);